var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentPage != null)?_c('div',[_c('transition',{attrs:{"name":"fade"}},[_c('cSplashElement',{attrs:{"element":_vm.currentPage}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }